import React from 'react';
import styles from './LegalPage.module.css';

const sections = [
	{
		title: 'What we collect',
		paragraphs: [
			'Calcium may collect information you provide directly, such as your name, username, email address, profile image, workout preferences, goals, routines, comments, messages, plan selections, support requests, and optional free-text details you choose to share like workout limitations or special requests.',
			'We may also collect technical and usage data such as device information, app activity, pages viewed, workout interactions, notifications, billing status, and diagnostics needed to keep the product secure and reliable.'
		]
	},
	{
		title: 'How we use your information',
		paragraphs: [
			'We use your information to operate Calcium, personalize routines and recommendations, power social features, process subscriptions, improve product quality, send notifications, and support your account.',
			'When you use AI-powered features like plan generation or Cali, relevant profile and workout context may be processed to produce more useful responses and suggestions. That may include goals, workout preferences, and optional notes you provide for those features.'
		]
	},
	{
		title: 'Community and profile visibility',
		paragraphs: [
			'Your profile, public routines, comments, and certain activity may be visible to other Calcium users depending on the privacy settings of the relevant feature.',
			'If you publish community content, share a routine, or invite others to train, the related information may be shown to the people involved so the feature can work as intended.'
		]
	},
	{
		title: 'Payments and third parties',
		paragraphs: [
			'Subscriptions and related payments may be processed by third-party providers such as app stores, PayPal, or other payment partners. Calcium does not store full payment card details directly in the app experience shown here.',
			'We may also rely on service providers for hosting, analytics, authentication, notifications, email delivery, and AI tooling. Those providers only receive the information needed to perform their role, and some features may require relevant workout or message context to be processed by those providers.'
		]
	},
	{
		title: 'Your choices',
		paragraphs: [
			'You can update certain account details in the product, control some notification preferences, and choose what routines or content you share publicly.',
			'If you want to request access, correction, or deletion of your data, contact us and we will review the request in line with applicable law and legitimate safety or record-keeping needs.'
		]
	},
	{
		title: 'Retention and security',
		paragraphs: [
			'We retain data for as long as it is reasonably needed to provide the service, comply with legal obligations, resolve disputes, and prevent abuse.',
			'Calcium uses technical and organizational safeguards, including encryption, to help protect potentially sensitive user data.',
			'Please avoid sharing passwords, payment card numbers, or highly sensitive medical information in free-text fields.'
		]
	},
];

const PrivacyPage = () => (
	<div className={styles.LegalPage}>
		<header className={styles.Hero}>
			<span className={styles.Eyebrow}>Legal</span>
			<h1 className={styles.Title}>Privacy Policy</h1>
			<p className={styles.Intro}>
				This policy explains what information Calcium collects, how it is used, and the choices you have.
				It is tailored to the current product experience, including routine creation, social features, subscriptions,
				notifications, and AI-assisted coaching.
			</p>
			<p className={styles.Meta}>Last updated: March 2026</p>
		</header>

		<div className={styles.SectionList}>
			{sections.map((section) => (
				<section key={section.title} className={styles.SectionCard}>
					<h2 className={styles.SectionTitle}>{section.title}</h2>
					{section.paragraphs.map((paragraph) => (
						<p key={paragraph} className={styles.Paragraph}>{paragraph}</p>
					))}
				</section>
			))}
		</div>

		<section className={styles.ContactCard}>
			<h2 className={styles.SectionTitle}>Contact</h2>
			<p className={styles.Paragraph}>
				Questions about privacy or data handling can be sent to <a href='mailto:hello@calcium.fitness'>hello@calcium.fitness</a>.
			</p>
			<p className={styles.Paragraph}>
				If we make material updates to this policy, we will update the effective date and reflect the latest version here.
			</p>
		</section>
	</div>
);

export default PrivacyPage;
